import { Dispatch, ForwardedRef, forwardRef, SetStateAction } from 'react';
import { useTranslation } from 'react-i18next';

import { Button, HiddenFileUpload } from 'coreOld/components';
import { DropdownItem, DropdownMenu } from 'coreOld/elements';
import { ImportType } from 'corporate/enums';

import { Wrapper } from './uploadFileStyle';

const dropdownItems = [
  {
    label: 'Part Numbers and Costs',
    type: ImportType.PARTS_COSTS,
  },
  {
    label: 'UOM Conversions',
    type: ImportType.UOMS,
  },
  {
    label: 'Vendor Costs',
    type: ImportType.VENDOR_COST,
  },
  {
    label: 'Part Attributes',
    type: ImportType.PART_ATTRIBUTES,
  },
];

interface IProps {
  isMenuOpen: boolean;
  setIsMenuOpen: Dispatch<SetStateAction<boolean>>;
  onItemClick: () => void;
  onChange: (e, type: ImportType) => void;
}

const UploadFileView = forwardRef<HTMLUListElement, IProps>(function UploadFileView(
  { isMenuOpen, setIsMenuOpen, onChange, onItemClick }: IProps,
  ref: ForwardedRef<HTMLUListElement>
) {
  const { t } = useTranslation();

  return (
    <Wrapper>
      <Button onClick={() => setIsMenuOpen((prev) => !prev)}>{t('buttonLabelImport')}</Button>

      <DropdownMenu
        onClick={onItemClick}
        isOpen={isMenuOpen}
        ref={ref as ForwardedRef<HTMLUListElement>}
      >
        {dropdownItems.map((item) => (
          <DropdownItem key={item.label}>
            <HiddenFileUpload
              name={item.type}
              label={item.label}
              onChange={(e) => onChange(e, item.type)}
            />
          </DropdownItem>
        ))}
      </DropdownMenu>
    </Wrapper>
  );
});

export default UploadFileView;
